<template>
  <rh-painel-acesso>
    <p class="rh-kicker">ACESSO SEGURO</p>
    <h1>Recuperar senha</h1>
    <p>Informe o e-mail cadastrado. Se houver uma conta ativa, enviaremos um link que vale por uma hora.</p>
    <b-message v-if="erro" type="is-danger">{{ erro }}</b-message
    ><b-message v-if="enviado" type="is-success">{{ enviado }}</b-message
    ><ValidationObserver v-slot="{ handleSubmit }" slim
      ><form @submit.prevent="handleSubmit(enviar)">
        <ValidationProvider v-slot="{ errors }" name="E-mail" rules="required|email"
          ><b-field label="E-mail" :type="errors.length ? 'is-danger' : ''" :message="errors[0]"
            ><b-input v-model.trim="email" type="email" autocomplete="email"></b-input></b-field></ValidationProvider
        ><b-button type="is-primary" native-type="submit" expanded :loading="salvando">Enviar instruções</b-button>
      </form></ValidationObserver
    ><router-link to="/rh" class="rh-back">Voltar ao login</router-link>
  </rh-painel-acesso>
</template>
<script>
import http from '@/http'
import RhPainelAcesso from '@/components/rh_painel_acesso.vue'
export default {
  name: 'RhRecuperar',
  components: { RhPainelAcesso },
  data() {
    return { email: '', erro: '', enviado: '', salvando: false }
  },
  methods: {
    async enviar() {
      this.salvando = true
      this.erro = ''
      try {
        this.enviado = (await http.post('/api/rh/auth/esqueci-senha', { email: this.email })).data.mensagem
      } catch (e) {
        this.erro = e && e.data && e.data.erro ? e.data.erro : 'Não foi possível solicitar a recuperação.'
      } finally {
        this.salvando = false
      }
    },
  },
}
</script>
